import { render, staticRenderFns } from "./TaskCreationForm.vue?vue&type=template&id=67cd90c8&scoped=true&"
import script from "./TaskCreationForm.vue?vue&type=script&lang=js&"
export * from "./TaskCreationForm.vue?vue&type=script&lang=js&"
import style0 from "./TaskCreationForm.vue?vue&type=style&index=0&id=67cd90c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cd90c8",
  null
  
)

/* custom blocks */
import block0 from "./TaskCreationForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports